export default {"src":"/_next/static/media/settings-active-icon.3e337b4d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};